import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-6 text-center flex"
}
const _hoisted_2 = { class: "bg-white inline-flex items-center rounded-full border border-primary30 px-5 py-3 text-sm text-primary30" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "12",
  viewBox: "0 0 10 12",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.33008 10.3335L0.666585 1.66683",
    stroke: "#2F7F91",
    "stroke-width": "1.33333",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.669922 10.3335L9.33341 1.66683",
    stroke: "#2F7F91",
    "stroke-width": "1.33333",
    "stroke-linecap": "round"
  })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = {
  key: 0,
  class: "text-center text-gray-500 p-10"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Nenhum histórico de edição encontrado para o período selecionado.", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "text-center text-sm text-gray-400 mt-6"
}

import { computed, ref, watch } from 'vue'
import { mdiHistory, mdiCalendarBlankOutline } from '@mdi/js'
import { useToast } from 'vue-toastification'
import BaseSidebar from '@/components/designSystem/Sidebar/BaseSidebar.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import FilterHistory from '@/components/Filters/FilterHistory.vue'
import HistoryCard from '@/components/designSystem/Cards/HistoryCard.vue'
import EditHistoryService from '@/Network/Services/EditHistoryService'
import { EditHistoryItem } from '@/Network/Types/Responses/EditHistoryResponses'
import Spinner from '@/components/others/Spinner.vue'

const itemsPerPage = 10


export default /*#__PURE__*/_defineComponent({
  __name: 'HistorySidebar',
  props: {
    isOpen: { type: Boolean },
    doctorStationId: {}
  },
  emits: ["update:isOpen"],
  setup(__props: any, { emit }) {

const props = __props;

const toast = useToast()
const editHistoryService = new EditHistoryService()





const isOpenFilterHistory = ref(false)
const appliedDateFilter = ref<{
  startDate: string | Date | null
  endDate: string | Date | null
} | null>(null)

const historyItems = ref<EditHistoryItem[]>([])
const loading = ref(false)
const currentPage = ref(1)
const totalItems = ref(0)
const hasMorePages = computed(() => historyItems.value.length < totalItems.value)

const modelValue = computed({
  get: () => props.isOpen,
  set: (value) => {
    emit('update:isOpen', value)
  }
})

const formatDate = (dateValue: string | Date | null): string => {
  if (!dateValue) return ''
  const date = new Date(dateValue)
  date.setMinutes(date.getMinutes() + date.getTimezoneOffset())
  if (isNaN(date.getTime())) return ''
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  return `${day}/${month}/${year}`
}

const formattedDateFilter = computed(() => {
  const start = appliedDateFilter.value?.startDate
    ? formatDate(appliedDateFilter.value.startDate)
    : null
  const end = appliedDateFilter.value?.endDate ? formatDate(appliedDateFilter.value.endDate) : null
  if (start && end) return `${start} - ${end}`
  if (start) return `A partir de ${start}`
  if (end) return `Até ${end}`
  return ''
})

function handleApplyFilters(filters: {
  startDate: string | Date | null
  endDate: string | Date | null
}) {
  appliedDateFilter.value = filters
  isOpenFilterHistory.value = false
  fetchHistory(true)
}

function clearDateFilter() {
  appliedDateFilter.value = null
  fetchHistory(true)
}

function handleOpenFilter() {
  isOpenFilterHistory.value = !isOpenFilterHistory.value
}

function handleCloseFilter() {
  isOpenFilterHistory.value = false
}

function handleRequestNew() {
  if (hasMorePages.value) {
    currentPage.value += 1
    fetchHistory()
  }
}

const doctorStationTimezone = ref<string | undefined>()

async function fetchHistory(reset = false) {
  if (!props.doctorStationId) {
    historyItems.value = []
    return
  }
  if (loading.value) return

  if (reset) {
    currentPage.value = 1
    historyItems.value = []
    totalItems.value = 0
  }

  loading.value = true
  try {
    const response = await editHistoryService.getHistory({
      doctorStationId: props.doctorStationId,
      startDate: appliedDateFilter.value?.startDate,
      endDate: appliedDateFilter.value?.endDate,
      page: currentPage.value,
      limit: itemsPerPage
    })
    const newItems = response.data.filter((item) => item?.changes && item?.changes?.length > 0)
    historyItems.value.push(...newItems)
    if (response.count != null) {
      totalItems.value = response.count
    }
    doctorStationTimezone.value = response.doctorStationTimezone
  } catch (err) {
    console.error('Erro ao buscar histórico', err)
    toast.error('Erro ao carregar o histórico de edições.')
  } finally {
    loading.value = false
  }
}

watch(
  () => props.isOpen,
  (isOpen) => {
    if (isOpen) {
      fetchHistory(true)
    }
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseSidebar, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    title: "Histórico de edição",
    description: "Consulte todas as alterações feitas nos plantões, com a opção de filtrar por período.",
    iconRight: _unref(mdiCalendarBlankOutline),
    icon: _unref(mdiHistory),
    sizeIcon: true,
    onOpenFilter: handleOpenFilter,
    isIconRightActive: isOpenFilterHistory.value
  }, {
    footer: _withCtx(() => [
      (hasMorePages.value)
        ? (_openBlock(), _createBlock(FilledButton, {
            key: 0,
            text: "Carregar Mais",
            width: "100%",
            class: "!bg-primary30 mt-6",
            disabled: loading.value,
            loading: loading.value,
            onClick: handleRequestNew
          }, null, 8, ["disabled", "loading"]))
        : (historyItems.value.length > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Fim do histórico "))
          : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(FilterHistory, {
        "is-open": isOpenFilterHistory.value,
        onClose: handleCloseFilter,
        onApplyFilters: handleApplyFilters
      }, null, 8, ["is-open"]),
      (formattedDateFilter.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, [
              _createElementVNode("span", null, _toDisplayString(formattedDateFilter.value), 1),
              _createElementVNode("button", {
                onClick: clearDateFilter,
                class: "ml-2 text-gray-500 hover:text-gray-700 font-bold focus:outline-none",
                "aria-label": "Limpar filtro"
              }, _hoisted_4)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (loading.value && historyItems.value.length === 0)
          ? (_openBlock(), _createBlock(Spinner, {
              key: 0,
              color: "primary",
              size: "5rem",
              width: "0.5rem",
              class: "absolute inset-0 flex justify-center items-center bg-white bg-opacity-50 z-50 mt-10"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass({ 'opacity-50': loading.value && historyItems.value.length > 0 })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyItems.value, (item) => {
            return (_openBlock(), _createBlock(HistoryCard, {
              key: item.id,
              type: item.type,
              user: item.user,
              createdAt: item.createdAt,
              changes: item.changes,
              timezone: doctorStationTimezone.value,
              "is-auto-permanence": item.isAutoPermanence,
              "permanence-note": item.permanenceNote,
              class: "mb-4"
            }, null, 8, ["type", "user", "createdAt", "changes", "timezone", "is-auto-permanence", "permanence-note"]))
          }), 128)),
          (historyItems.value.length === 0 && !loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "iconRight", "icon", "isIconRightActive"]))
}
}

})